(function () {
  var s = localStorage.getItem("theme");
  var d = window.matchMedia("(prefers-color-scheme:dark)").matches;
  document.documentElement.setAttribute(
    "data-theme",
    s === "dark" || s === "light" ? s : d ? "dark" : "light",
  );
})();
